export default __webpack_public_path__ + "assets/mp3/4ab3c5fd79d930fb25d2870dcbe9900f.mp3";